import { HeroBannerType } from 'shared/types'
import { featureFlags } from './app-feature-flags'

/**
 * False while the stand hides the on-chain UI (`offchainOnly`): the wallet
 * controls and dialogs, the USDT balance, mint/deposit/withdraw, the Staking
 * and Airdrop cards, the banners about the chain, the live wins of on-chain
 * bets, the cashback and the referral bonus withdrawals. The UI stays in
 * place for the switch back to on-chain.
 */
export const isOnchainUiShown = () => !featureFlags.offchainOnly

/** Hero banners about the chain: "Everything is on-chain…", Mainnet, Chainlink. */
export const ONCHAIN_BANNERS: readonly HeroBannerType[] = [
  'mainnet',
  'web3',
  'chainlink'
]

/** `banners` without the ones about the chain while the stand hides them. */
export const getShownBanners = (banners: readonly HeroBannerType[]) =>
  isOnchainUiShown() ?
    [...banners]
  : banners.filter(banner => !ONCHAIN_BANNERS.includes(banner))
